import angular from 'angular';
import template from './resetPassword.html';

class ResetPasswordController {
    constructor($uibModal, DataApiService) {
        'ngInject';
        this.$uibModal = $uibModal;
        this.DataApiService = DataApiService;
    }

    $onInit() {
        this.token = this.token || '';
        this.resetSuccess = false;
        this.hasResendPwLink = false;

        this.isCheckingToken = true;
        this.DataApiService.checkResetPasswordToken(this.token)
            .then(result => {
                this.isCheckingToken = false;
                this.isValidToken = !!result.isValidToken;
            });
    }

    handleSubmitPassword(event) {
        let password = event.password;
        this.DataApiService.resetPassword(this.token, password)
            .then(() => {
                this.resetSuccess = true;
            });
    }

    handleResendPwLink() {
        let modal = this.$uibModal.open({
            backdropClass: 'mms-backdrop',
            component: 'mmsForgotPasswordModal',
            windowClass: 'modal-pw'
        });
        modal.result
            .then(() => {
                this.hasResendPwLink = true;
            })
            .catch(() => {
                this.hasResendPwLink = false;
            });
    }

}

export const ResetPasswordComponent = {
    name: 'mmsResetPassword',
    component: {
        template,
        controller: ResetPasswordController,
        bindings: {
            token: '<',
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/pages/resetPw/resetPassword.component.js